import { GraphQLObjectType, GraphQLString } from 'graphql';

const Distractor = new GraphQLObjectType({
  name: 'Distractor',
  fields: () => ({
    id: {
      type: GraphQLString,
      resolve: item => item._id.toString()
    },
    text: {
      type: GraphQLString
    }
  })
});

window[Distractor.name + 'GQLType'] = Distractor;

export default Distractor;
